import {Component} from "../interface/component";
import EventsHandler from "../service/events";
import EVENTS from "../constants/events";

export class LenisScrollComponent implements Component {
    private lenis: any;
    private events:EventsHandler;

    init() {
        //Having issues getting this npm package to build, so pull it in externally
        /** @ts-ignore **/
        if (undefined === window.Lenis){
            return;
        }
        this.events.addListener(EVENTS.NAVIGATION_SHOW, this.onMobileNavOpen);
        this.events.addListener(EVENTS.NAVIGATION_HIDE, this.onMobileNavClose);

        setTimeout(() => {
            this.setupLenis();
        }, 250);
    }

    requestAnimationFrame = (time:any) => {
        if (undefined !== this.lenis) {
            this.lenis.raf(time);
        }
        requestAnimationFrame(this.requestAnimationFrame);
    }

    private setupLenis = () => {
        /** @ts-ignore **/
        this.lenis = new Lenis();
        requestAnimationFrame(this.requestAnimationFrame);
    }

    private onMobileNavOpen = () => {
        this.lenis.destroy();
        this.lenis = undefined;
    }

    private onMobileNavClose = () => {
        this.setupLenis();
    }

    public setEventHandler(events:EventsHandler) {
        this.events = events;
    }
}
